import { mq } from './Layout.styles'
import styled from '@emotion/styled'
import Atom from './Atom.styles'

/* Default sizes change if you need */
export const StyledH2 = styled(Atom)(props => (
  mq({
    fontWeight: ['normal'],
    letterSpacing: [-0.5],
    lineHeight: ['normal']
  })
))
